import server from "./server";

export const getAllApi = async ({applicationId}) => {
  const response = await server().get(
    `/partners/applications/${applicationId}/subscriptions`
  );

  return response.data;
};

export const addApi = async (data) => {
  const response = await server().post(
    "/partners/applications/subscriptions",
    data
  );

  return response.data;
};

export const getApi = async (id) => {
  const response = await server().get(
    `/partners/applications/subscriptions/${id}`
  );

  return response.data;
};

export const editApi = async ({ id, data }) => {
  const response = await server().put(
    `/partners/applications/subscriptions/${id}`,
    data
  );

  return response.data;
};

export const deleteApi = async (id) => {
  const response = await server().delete(
    `/partners/applications/subscriptions/${id}`
  );

  return response.data;
};
